import React from 'react';
import { useSelector } from 'react-redux';
import { selectedAnalysisEntityState } from '@Data/qualityControl/Reducer';
import Styles from '../../QualityControlBlock.scss';
import { EntityDataRow } from '../EntityDataRow/EntityDataRow';

interface IBasicJobInfoProps {
    className?: string;
}

export const BasicJobInfo = ({
    className = Styles.basicJobInfoContainer,
}: IBasicJobInfoProps) => {
    const selectedAnalysisEntity = useSelector(selectedAnalysisEntityState);

    return (
        <div className={className}>
            <EntityDataRow
                keyName="Current status"
                value={selectedAnalysisEntity?.status ?? '-'}
            />
            <EntityDataRow
                keyName="Last modified by"
                value={selectedAnalysisEntity?.updated_by_name ?? '-'}
            />
        </div>
    );
};
